<nz-card class="flow-card" nzTitle="Installation Date">
  <p class="flow-card__subtitle">Choose the next available time slot that works best for the customer.</p>

  <nz-radio-group class="install-slots" [(ngModel)]="selectedSlot" (ngModelChange)="onRadioChange($event)">
    <nz-collapse [nzAccordion]="false">
      <nz-collapse-panel
        *ngFor="let date of (showAllDates ? availableDates : (availableDates | slice:0:5))"
        [nzHeader]="formatDate(date.date)"
        [nzActive]="isDateActive(date)"
        class="install-day"
      >
        <ng-container *ngIf="date.slots?.length; else noSlots">
          <label
            nz-radio
            class="install-slot"
            *ngFor="let t of date.slots"
            [nzValue]="t"
            (click)="labelClick(t)"
          >
            {{ formatTime(t.windowStartTime) }} – {{ formatTime(t.windowEndTime) }}
          </label>
        </ng-container>
        <ng-template #noSlots>
          <span class="install-empty">No times found.</span>
        </ng-template>
      </nz-collapse-panel>
    </nz-collapse>
  </nz-radio-group>

  <div class="flow-actions" *ngIf="availableDates?.length > 3">
    <button nz-button nzType="default" nzBlock (click)="toggleShowAll()">
      {{ showAllDates ? 'Show fewer days' : 'Show more days' }}
    </button>
  </div>

  <div class="flow-actions flow-actions--trailing">
    <button nz-button nzType="primary" nzBlock [disabled]="!selectedSlot" (click)="submitTime()" [nzLoading]="submitting">
      Next Step
    </button>
  </div>
</nz-card>
